import { Grid, Typography, Box, TextField, MenuItem } from "@mui/material";
import usePersonStore from "../../../../store/personStore";
import { useEffect, useState } from "react";
import { SelectOption } from "../../../../../components/Form/SelectField/SelectField";
export type SelectScreenProps = {
    onSelect: (option: string) => void;
}
interface SearchOptionType {
    label: string | null,
    value: string | null
}

const TRIAGE_SEARCH_OPTION: SearchOptionType[] = [
    {
        label: "Launch Date",
        value: "launchDate",
    }
]
const mapSelectOptions = (options: any[]): SelectOption[] => options.map(x => ({
    label: x.label,
    value: x.value,
    isDefault: x.value === "launchDate"
}))
export default function SelectSearchOption({ onSelect }: SelectScreenProps) {
    const defaultLocation = usePersonStore(state => state.company.defaultLocation)
    const [options, setOptions] = useState<SelectOption[]>(mapSelectOptions(TRIAGE_SEARCH_OPTION))
    useEffect(() => {
        const temp = [...TRIAGE_SEARCH_OPTION]
        if (defaultLocation?.customFields) {
            for (let i = 0; i < defaultLocation.customFields.length; i++) {
                temp.push({
                    value: defaultLocation.customFields[i].id,
                    label: defaultLocation.customFields[i].name
                })
            }
        }
        setOptions(mapSelectOptions(temp))
    }, [defaultLocation])
    return (
        <Grid size={12} textAlign="center">
            <Typography >How would you like to collect the data</Typography>
            <Box sx={{ paddingTop: ".5rem" }}>
                <TextField name="searchParam"
                    fullWidth
                    select
                    required
                    label="Select"
                    onChange={(choice) => {
                        onSelect(choice.target.value)
                    }}
                >
                    {options.map((option) => (
                        <MenuItem value={option.value}>{option.label}</MenuItem>
                    ))}
                </TextField>
            </Box>

        </Grid>
    )
}